document.addEventListener("DOMContentLoaded", function () {

  document.querySelectorAll(".tab-global").forEach(container => {

    const arrayRoleTabs = container.querySelectorAll('[role="tab"]');
    const arrayRoleTabPanels = container.querySelectorAll('[role="tabpanel"]');
    const jsTabList = container.querySelector(".js-tab-global__list");

    if (!arrayRoleTabs.length || !arrayRoleTabPanels.length) return;

    function activateTab(tab, setFocus = false) {
      arrayRoleTabs.forEach(t => {
        t.setAttribute("aria-selected", "false");
        t.setAttribute("tabindex", "-1");
      });

      tab.setAttribute("aria-selected", "true");
      tab.setAttribute("tabindex", "0");

      if (setFocus) {
        tab.focus();
      }

      const targetId = tab.getAttribute("aria-controls");

      arrayRoleTabPanels.forEach(panel => {
        panel.classList.toggle(
          "state-tab-global__panel--active",
          panel.id === targetId
        );
      });
    }

    function onKeydown(e, tab) {
      const tabs = Array.from(arrayRoleTabs);
      const index = tabs.indexOf(tab);
      let newIndex = null;

      switch (e.key) {
        case "ArrowRight":
        case "ArrowDown":
          newIndex = (index + 1) % tabs.length;
          break;
        case "ArrowLeft":
        case "ArrowUp":
          newIndex = (index - 1 + tabs.length) % tabs.length;
          break;
        case "Home":
          newIndex = 0;
          break;
        case "End":
          newIndex = tabs.length - 1;
          break;
        default:
          return;
      }

      e.preventDefault();
      activateTab(tabs[newIndex], true);
    }

    function updateTabsShadows() {
      if (!jsTabList) return;

      const scrollLeft = jsTabList.scrollLeft;
      const maxScrollLeft = jsTabList.scrollWidth - jsTabList.clientWidth;

      container.classList.toggle(
        "tab-global--helper-scrollable-left",
        scrollLeft > 0
      );
      container.classList.toggle(
        "tab-global--helper-scrollable-right",
        Math.ceil(scrollLeft) < maxScrollLeft
      );
    }
    function updatePagerTab(tabIndex) {
      const pagerLinks = container.querySelectorAll('.pager a, .pagination a');

      pagerLinks.forEach(link => {
        try {
          const url = new URL(link.href, window.location.origin);
          url.searchParams.set('tab', tabIndex);
          link.href = url.toString();
        } catch (e) {
          // ignore invalid URLs
        }
      });
    }

    window.addEventListener("resize", updateTabsShadows);
    jsTabList?.addEventListener("scroll", updateTabsShadows);

    const params = new URLSearchParams(window.location.search);
    const tabIndexFromUrl = parseInt(params.get("tab"), 10);

    let initialTab;

    if (!isNaN(tabIndexFromUrl) && arrayRoleTabs[tabIndexFromUrl]) {
      initialTab = arrayRoleTabs[tabIndexFromUrl];
    } else {
      initialTab =
        Array.from(arrayRoleTabs).find(t => t.getAttribute("aria-selected") === "true")
        || arrayRoleTabs[0];
    }

    arrayRoleTabs.forEach(tab => {

      tab.addEventListener("click", () => {
        const tabs = Array.from(arrayRoleTabs);
        const index = tabs.indexOf(tab);
        updatePagerTab(index);

        // update URL
        const url = new URL(window.location);
        url.searchParams.set("tab", index);
        window.history.replaceState({}, "", url);

        activateTab(tab, true);
      });

      tab.addEventListener("keydown", e => onKeydown(e, tab));
    });

    activateTab(initialTab);
    updateTabsShadows();
  });
});
